export default "__VITE_ASSET__BGM8wFFe__"